const oneTimePurchaseForms = new WeakSet();

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-lyckd-one-time]');
  const purchase = button?.closest('[data-lyckd-purchase]');
  const form = purchase && document.getElementById(purchase.dataset.productFormId);
  const addButton = form?.querySelector('button[type="submit"][name="add"]');
  if (!addButton || addButton.disabled) return;

  oneTimePurchaseForms.add(form);
  try {
    form.requestSubmit(addButton);
  } finally {
    oneTimePurchaseForms.delete(form);
  }
});

document.addEventListener('formdata', (event) => {
  const form = event.target;
  const purchase = [...document.querySelectorAll('[data-lyckd-purchase]')].find(
    (option) => option.dataset.productFormId === form.getAttribute('id'),
  );
  if (!purchase) return;

  const selectedPlanId = oneTimePurchaseForms.has(form)
    ? ''
    : purchase.querySelector('input[name="selling_plan"]:checked')?.value;

  if (selectedPlanId) {
    event.formData.set('selling_plan', selectedPlanId);
  } else {
    event.formData.delete('selling_plan');
  }
  event.formData.set('quantity', '1');
  oneTimePurchaseForms.delete(form);
}, true);
